import React, { Component } from "react";
import "./Services.css";
import "aos/dist/aos.css";
import Aos from "aos";

class Services extends Component {
  componentDidMount() {
    this.aos = Aos;
    this.aos.init({
      duration: 1500,
    });
  }
  componentDidUpdate() {
    this.aos.refresh();
  }
  render() {
    return (
      <div className="services" id="services">
        <div className="services__title">
          <h2>our services</h2>
          <p>
            We take a holistic approach to eCommerce.
          </p>
          <hr />
        </div>
        <div className="services__content">
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/analysis.png")} alt="" />
            <h4>Free Klaviyo Audit</h4>
            <p>
              Discover the secrets that will increase your eCommerce store's sales by 30% with an absolutely FREE Audit. 
              Normally costs around £500.
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/strategy.png")} alt="" />
            <h4>Customer Retention</h4>
            <p>
              Use advanced automation and segmentation to build personalised relationships with your customers.
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/flow.png")} alt="" />
            <h4>Dynamic Flows</h4>
            <p>
             Recover abandoned carts, welcome new customers, nurture leads and more!
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/segment.png")} alt="" />
            <h4>40+ Segmentations</h4>
            <p>
              Build segments using behavioral and transactional data to target promotions more precisely.
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/upsell.png")} alt="" />
            <h4>Up-Sell/Cross-Sell </h4>
            <p>
              Sell more when you can.
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/email.png")} alt="" />
            <h4>Email Campaign</h4>
            <p>
             Delight your customers with instant gratification.
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/form.png")} alt="" />
            <h4>Forms & Popups</h4>
            <p>
              Grow your engaged email list with signup forms and pop ups.
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/analytics.png")} alt="" />
            <h4>Analytics & Reports</h4>
            <p>
              Get the information you want in minutes, not days.
            </p>
          </div>
          <div className="services__name" data-aos="fade-up">
            <img src={require("../Img/services/chatbot.png")} alt="" />
            <h4>ChatBots & SMS</h4>
            <p>
             Targeted and personalised marketing via Manychat, ReCart, Chatfuel or SMSBump.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
